// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileTextWithLabel_container__1oPrd","label":"ProfileTextWithLabel_label__32BgS","text":"ProfileTextWithLabel_text__2_KTl"};